// @ts-nocheck
import { createBrowserHistory, History } from '/data/jenkins/workspace/aplus_tiger_202111invite8a39a4a0-63c6-401a-b0da-8b1d91baec64_tiger-platform_huya-promo_202111invite_19893_nodejs_prod@2/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';

let options = {
  "basename": "/h5/202111invite/"
};
if ((<any>window).routerBase) {
  options.basename = (<any>window).routerBase;
}

// remove initial history because of ssr
let history: History = process.env.__IS_SERVER ? null : createBrowserHistory(options);
export const createHistory = (hotReload = false) => {
  if (!hotReload) {
    history = createBrowserHistory(options);
  }

  return history;
};

export { history };
